import React from 'react'
import { Modal, ModalBody } from 'reactstrap'

const StatusPopup = ({ isStatusModalOpen, toggle, size = 'md', children }) => {
  return (
    <Modal size={size} centered isOpen={isStatusModalOpen} toggle={toggle}>
      <ModalBody className="p-5">{children}</ModalBody>
    </Modal>
  )
}

export default StatusPopup
